import { type FC, type ReactNode } from 'react';
import classnames from 'classnames';

import { Link } from 'dibs-elements/exports/Link.tsx';

import dibsCss from 'dibs-css';

const GetHelpZendeskGroupTopicLink: FC<{
    onClick: () => void;
    children: ReactNode;
}> = ({ onClick, children }) => {
    return (
        <Link
            onClick={onClick}
            underline="none"
            className={classnames(dibsCss.block, dibsCss.textLeft)}
        >
            <span className={classnames(dibsCss.sassyFontBodyMediumHeavy, dibsCss.textPitchblack)}>
                {children}
            </span>
        </Link>
    );
};

export { GetHelpZendeskGroupTopicLink };
